import { useState } from "react";
import ModalLayout from "../layouts/ModalLayout";
import CustomInput from "../CustomInput";
import CustomButton from "../CustomButton";
import feesAndPaymentApis from "../../api/feesAndPaymentApis";
import { toast } from "sonner";

interface Props {
  invoiceId: number;
  onClose: () => void;
  onSuccess: () => void;
}

export default function MarkAsPaidModal({
  invoiceId,
  onClose,
  onSuccess,
}: Props) {
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!amount) {
      toast.error("Please enter amount");
      return;
    }

    try {
      setLoading(true);

      await feesAndPaymentApis.updateInvoiceStatus(
        invoiceId,
        "PAID",
        Number(amount),
      );

      toast.success("Invoice marked as paid");
      onSuccess();
      onClose();
    } catch (error) {
      // handled in API
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalLayout onClose={onClose} width="max-w-md">
      <div className="flex flex-col gap-5">
        <h4 className="text-lg font-semibold text-neutral-400">
          Paid Invoice 
        </h4>

        <CustomInput
          name="amount"
          label="Enter Amount"
          placeholder="Enter amount received"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          required
        />

        <div className="flex justify-end gap-4">
          <CustomButton
            text="Cancel"
            color="bg-neutral-200"
            onClick={onClose}
            type="button"
          />

          <CustomButton
            text={loading ? "Processing..." : "Confirm"}
            color="bg-success-600"
            onClick={handleSubmit}
            type="button"
          />
        </div>
      </div>
    </ModalLayout>
  );
}
